// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__16qYq","topBottomGutter":"Layout_topBottomGutter__DbCu2"};